module.exports = __webpack_public_path__ + "static/media/care-advice-mobile.948147cb.jpg";